<template>
  <div class="app-container">
    <CrudTable ref="table" entity="Language" :columns="columns" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
import crudIndexMixin from '@/mixins/crud-index';
export default {
  components: {
    CrudTable
  },
  mixins: [crudIndexMixin],
  data() {
    return {
      columns: [{ field: 'id', label: 'language.code' }, 'description']
    };
  }
};
</script>

<style scoped></style>
